/**
 * Client-side tier rules (must match server/src/utils/tierRules.js)
 */

export const ALL_DIMENSIONS = [
  'position', 'audio', 'voice', 'note', 'color', 'shape', 'number', 'face',
  'arrow', 'movement', 'pattern', 'border', 'orbitalPosition', 'circleSize',
  'circleRotation', 'circleBrightness', 'categoryText', 'categoryAudio',
  'nameText', 'nameAudio', 'math', 'rhythm', 'mandarinTone', 'volume'
];

export const TIER_RULES = {
  anonymous: {
    dailyRounds: 3,
    allowedDimensions: ['position', 'audio'],
    maxDimensions: 2,
    historyDays: 0,
    maxFavorites: 0,
    canSaveProgress: false,
    hasPassSystem: false
  },
  free: {
    dailyRounds: 8,
    allowedDimensions: ['position', 'color', 'audio'],
    maxDimensions: 2,
    historyDays: 30,
    maxFavorites: 3,
    canSaveProgress: true,
    hasPassSystem: false
  },
  pro: {
    dailyRounds: 999999,
    allowedDimensions: ALL_DIMENSIONS,
    maxDimensions: 999,
    historyDays: 999999,
    maxFavorites: 999,
    canSaveProgress: true,
    hasPassSystem: false,
    hasAdvancedAnalytics: true,
    hasPremiumContent: true,
    hasAllGames: true
  },
  // Alias for backwards compatibility
  paid: {
    dailyRounds: 999999,
    allowedDimensions: ALL_DIMENSIONS,
    maxDimensions: 999,
    historyDays: 999999,
    maxFavorites: 999,
    canSaveProgress: true,
    hasPassSystem: false,
    hasAdvancedAnalytics: true,
    hasPremiumContent: true,
    hasAllGames: true
  }
};

export function getTierRules(tier) {
  return TIER_RULES[tier] || TIER_RULES.free;
}

export function isDimensionAllowed(dimension, tier) {
  const rules = getTierRules(tier);
  return rules.allowedDimensions.includes(dimension) || 
         rules.allowedDimensions === ALL_DIMENSIONS;
}

export function canSelectDimensions(selectedDimensions, tier) {
  const rules = getTierRules(tier);
  
  // Check if too many dimensions selected
  if (selectedDimensions.length > rules.maxDimensions) {
    return {
      allowed: false,
      reason: `Maximum ${rules.maxDimensions} dimensions allowed for ${tier} tier`
    };
  }
  
  // Check if all dimensions are allowed
  const disallowed = selectedDimensions.filter(d => !isDimensionAllowed(d, tier));
  if (disallowed.length > 0) {
    return {
      allowed: false,
      reason: `Dimensions not allowed: ${disallowed.join(', ')}`,
      disallowed
    };
  }
  
  return { allowed: true };
}

